import _ from 'lodash';
import IApplicationState from 'app/types/state';
import { IPaymentRequest } from 'app/ducks/paymentRequests/types';

export function getCurrentPaymentRequest(state: IApplicationState) {
  if (
    state.paymentRequests.paymentRequestsById !== undefined
    && state.paymentRequests.currentPaymentRequestId !== undefined
  ) {
    const pc = state.paymentRequests.paymentRequestsById[
      state.paymentRequests.currentPaymentRequestId
    ];
    return pc;
  }
  return {};
}

export function getCurrentFormPaymentRequest(state: IApplicationState) {
  return {
    ...getCurrentPaymentRequest(state),
    ...state.paymentRequests.requestedData,
  };
}

export function getPaymentRequests(state: IApplicationState) {
  return {
    ...state.paymentRequests,
    currentPaymentRequest: {
      ...getCurrentPaymentRequest(state),
    },
  };
}

export function getPaymentRequestIdsByTeamId(
  paymentRequestsById: any,
  teamId,
) {
  if (paymentRequestsById !== undefined && teamId != null) {
    const filtered = _.filter(paymentRequestsById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

export function getPaymentRequestIdsByPaymentId(
  state: IApplicationState,
  paymentId,
) {
  if (
    state.paymentRequests.paymentRequestsById !== undefined
    && paymentId != null
  ) {
    const { paymentRequestsById } = state.paymentRequests;
    const filtered = _.filter(paymentRequestsById, {
      payment: { id: paymentId },
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

export function getPaymentRequestSummary(
  paymentRequest: IPaymentRequest,
): any {
  const paymentRequestSummary = {
    id: paymentRequest.id,
    summary: {
      description: paymentRequest.description,
      numberOfPeople: paymentRequest.numberOfPeople,
    },
    amount: paymentRequest.amount,
    status: paymentRequest.status,
    createdAt: paymentRequest.createdAt,
    collected: {
      collected: paymentRequest.collectedAmount,
      total: paymentRequest.totalAmount,
    },
    pendingPeople: paymentRequest.pending,
  };
  return paymentRequestSummary;
}
